import React from "react";

const Year = ({ year }) => {
  return <p className="year">{year}</p>;
};

export default Year;
